const employees = {
  employeesList: "Employees List",
  viewEmployee: "View Employee",
  editProfile: "Edit Profile",
  editEmployee: "Edit",
  deleteEmployee: "Delete",
  deleteEmployeeTitle: "Delete Employee",
  deleteEmployeeConfirm: "Are you sure you want to delete this employee?",
  deleteModalNo: "No",
  deleteModalYes: "Yes",
  editEmployeeTitle: "Edit Employee",
  showingRange: "Showing {from}-{to} of {total} employees",
  searchPlaceholder: "Search for an employee",
  noDataDescription: "Sorry, No employees found.",
  profile: "Profile",
  email: "Email",
  mobileNumber: "Mobile Number",
  addProjectManager: {
    createEmployee: "Add Employee",
    addEmployee: "Add Employee",
    name: "Name",
    email: "Email",
    mobileNumber: "Mobile number",
    jobTitle: "Job title",
    labels: {
      name: "Name",
      email: "Email",
      mobileNumber: "Mobile number",
      jobTitle: "Job title",
      employeeImage: "Employee Image",
      uploadLabel: "Upload Image",
      projectManager: "Project Manager",
    },
    placeholders: {
      name: "Enter name",
      email: "Enter email",
      mobileNumber: "Enter mobile number",
      jobTitle: "Select Job title",
      projectManager: "Select Project Manager",
    },
  },
  listEmployees: {
    name: "Name",
    email: "Email",
    mobile: "Mobile Number",
    jobTitle: "Job Title",
    actions: "Actions",
  },
};
export default employees;
